export default "__VITE_ASSET__CggHfo1p__"